import React, { useState } from 'react';
import { toPublicUrl } from '../constants';

interface SmartImageProps {
  src: string;
  alt: string;
  fallbackSrc?: string;
  width: number;
  height: number;
  className?: string;
  priority?: 'high' | 'low' | 'auto';
}

const SmartImage: React.FC<SmartImageProps> = ({ 
  src, 
  alt, 
  fallbackSrc, 
  width, 
  height, 
  className = '',
  priority = 'auto'
}) => {
  const [error, setError] = useState(false);
  
  const handleImageError = () => {
    // Prevent infinite loops by only swapping once
    if (!error) {
      setError(true);
    }
  };

  const finalSrc = error ? toPublicUrl(fallbackSrc) : toPublicUrl(src);

  return (
    <img
      src={finalSrc}
      alt={alt}
      width={width}
      height={height}
      className={className}
      loading={priority === 'high' ? 'eager' : 'lazy'}
      decoding="async"
      // @ts-ignore - fetchpriority is a valid HTML attribute but may not be in all TS versions
      fetchpriority={priority}
      onError={handleImageError}
    />
  );
};

export default SmartImage;
